<template>
  <RenewalTable :data="data">
    <template #header>
      <Grid gaf="column" justify-content="space-between" align-items="center">
        <div class="text-subtitle-1 text-secondary-2">FINANCIAL OVERVIEW</div>
        <RBtn type="link" to="/financial">go to financial insights</RBtn>
      </Grid>
    </template>
  </RenewalTable>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import RenewalTable from '@/reusable/renewal-table/RenewalTable'

export default {
  components: {
    RenewalTable
  },

  data: () => ({
    data: null
  }),

  created() {
    apiTo.GET_INFO_BOX_SUB_SPEND_OVERVIEW().then(({ data }) => (this.data = data.result))
  }
}
</script>
